export const HEROUI_PREFIX = '@heroui';
export const NEXTUI_PREFIX = '@nextui-org';

export const NEXTUI_PROVIDER = 'NextUIProvider';
export const HEROUI_PROVIDER = 'HeroUIProvider';

export const NEXTUI_PLUGIN = 'nextui';
export const HEROUI_PLUGIN = 'heroui';

export const NEXTUI_CSS_VARIABLES_PREFIX = '--nextui-';
export const HEROUI_CSS_VARIABLES_PREFIX = '--heroui-';

export const EXTRA_FILES = ['.storybook'];
